import React from 'react';

import { useBreakpointValue } from 'native-base';
import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

import { ListCardGroupVariant } from './types';

export const NUM_COLUMNS = 3;
export const CONTENT_CONTAINER_PADDING_MOBILE = 4;

export const ListCardGroupContainer = ({
  $isFullContainer,
  style,
  ...props
}: BoxProps & { $isFullContainer: boolean }) => {
  const hasDesktopPadding = useBreakpointValue({
    base: false,
    md: !$isFullContainer,
  });

  return React.createElement(Box, {
    ...props,
    style: [
      styles.listCardGroupContainer,
      hasDesktopPadding && styles.listCardGroupContainerDesktop,
      style,
    ],
  });
};

export const ListHeader = ({
  listCardGroupVariant,
  ...props
}: React.ComponentPropsWithoutRef<typeof Typography> & {
  listCardGroupVariant: ListCardGroupVariant;
}) =>
  React.createElement(Typography, {
    accessible: true,
    variant: 'headerTwo',
    fontSize: 16,
    my: '$2',
    px: '$2',
    mb: '$0',
    textAlign: listCardGroupVariant === ListCardGroupVariant.SINGLE ? 'center' : undefined,
    ...props,
  });

export const RenderItemRowContainer = ({
  listCardGroupVariant,
  style,
  ...props
}: BoxProps & {
  listCardGroupVariant: ListCardGroupVariant;
}) =>
  React.createElement(Box, {
    ...props,
    style: [
      styles.renderItemRowContainer,
      listCardGroupVariant === ListCardGroupVariant.SINGLE && styles.renderItemRowContainerSingle,
      style,
    ],
  });

const styles = StyleSheet.create({
  listCardGroupContainer: {
    width: '100%',
  },
  listCardGroupContainerDesktop: {
    paddingHorizontal: spacing.$64,
  },
  renderItemRowContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  renderItemRowContainerSingle: {
    justifyContent: 'center',
  },
});
